/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { copilotBillingEvent } from '../models/copilotBillingEvent';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CopilotBillingEventsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Emit a copilot billing event
   * @param requestBody
   * @returns any Billing event already exists (idempotency key matched)
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCopilotBillingEventsEmit(
    requestBody?: {
      /**
       * UUID of the company this billing event belongs to
       */
      companyUuid: string;
      /**
       * UUID of the user who triggered this billing event
       */
      userUuid: string;
      /**
       * Type of billing event (DEBIT or CREDIT)
       */
      eventType: 'DEBIT' | 'CREDIT';
      /**
       * The outcome type that triggered this billing event (e.g., shift_created)
       */
      outcomeType: string;
      /**
       * Number of credits for this event (negative values correct prior debits)
       */
      creditsAmount: number;
      /**
       * Unique key for idempotent event creation
       */
      idempotencyKey: string;
      /**
       * ID of the copilot conversation thread this event belongs to
       */
      threadId?: string;
      /**
       * Short human-readable label for the action (e.g. "Generated a report")
       */
      shortDescription?: string;
      /**
       * Detailed description of what happened
       */
      longDescription?: string;
      /**
       * Optional extensible metadata payload
       */
      metadata?: Record<string, any>;
    },
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/copilotBillingEvents/emit',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - validation error`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Add credits to a company balance
   * @param requestBody
   * @returns any Credits already added (idempotency key matched)
   * @throws ApiError
   */
  public postApiServiceorganizationsProcessesCopilotBillingEventsAddCredits(
    requestBody?: {
      /**
       * UUID of the company to add credits to
       */
      companyUuid: string;
      /**
       * Number of credits to add
       */
      creditsAmount: number;
      /**
       * Reason for adding credits
       */
      reason: 'INITIAL_CREDITS' | 'FOUNTAIN_CREDITS' | 'PACK_PURCHASE';
      /**
       * Unique key for idempotent credit addition
       */
      idempotencyKey: string;
      /**
       * Short human-readable label for the credit addition
       */
      shortDescription?: string;
      /**
       * Detailed description of why credits were added
       */
      longDescription?: string;
      /**
       * Optional extensible metadata payload
       */
      metadata?: Record<string, any>;
    },
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/serviceorganizations/processes/copilotBillingEvents/addCredits',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - validation error`,
        500: `Internal server error`,
      },
    });
  }

  /**
   * Get paginated transaction history for the authenticated company
   * @param cursor Pagination cursor (ISO 8601 timestamp of the last item from previous page)
   * @param limit Number of records per page (max 100)
   * @param startDate Filter events at or after this ISO 8601 date-time
   * @param endDate Filter events at or before this ISO 8601 date-time
   * @param eventType Filter by event type
   * @returns any Transaction history retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCopilotBillingTransactionHistory(
    cursor?: string,
    limit: number = 50,
    startDate?: string,
    endDate?: string,
    eventType?: 'DEBIT' | 'CREDIT',
  ): CancelablePromise<{
    data?: {
      /**
       * List of billing events
       */
      events?: Array<copilotBillingEvent>;
      pagination?: {
        limit?: number;
        hasNextPage?: boolean;
        /**
         * Pass as cursor in the next request to get the next page
         */
        nextCursor?: string | null;
      };
    };
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/copilotBilling/transactionHistory',
      query: {
        'cursor': cursor,
        'limit': limit,
        'startDate': startDate,
        'endDate': endDate,
        'eventType': eventType,
      },
      errors: {
        400: `Bad request - validation error`,
        500: `Internal server error`,
      },
    });
  }

}
